import {Downloadable} from './Downloadable'

export interface M<T> {
    readonly file: T
    readonly download: Downloadable
}

export function fromFile<T>(file: T): M<T> {
    return {file, download: {type: 'Default'}}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/DownloadableFile.ts